import { toast } from "react-toastify";
import { apiS } from "../config/config";

/**
 * Télécharge un fichier vers le serveur en utilisant une requête POST.
 *
 * @param {File} file - Le fichier à envoyer.
 * @param {Function} [setIsLoading=() => {}] - Fonction de mise à jour de l'état de chargement.
 * @returns {Promise<string|null>} - Le nom du fichier enregistré sur le serveur en cas de succès, sinon `null`.
 *
 */
export const handleFileUpload = async (
  file,
  setIsLoading,
) => {
  if (!file) return null;

  const formData = new FormData();
  formData.append("file", file);

  try {
    setIsLoading(true);
   
    const response = await apiS.post("", formData);

    if (response.status === 201) {
      return response.data.filename;
    }
  } catch (error) {
    console.error(error);
    toast.error("Échec de l'envoi du fichier.");
    return null;
  } finally {
    setIsLoading(false);
  }
};
